import { None } from "@siteimprove/alfa-option";
import { Thunk } from "@siteimprove/alfa-thunk";
export function expectation(test, ifTrue, ifFalse, ifUnknown = Thunk.of(None)) {
    switch (test) {
        case true:
            return ifTrue();
        case false:
            return ifFalse();
        default:
            return ifUnknown();
    }
}
//# sourceMappingURL=expectation.js.map